import React, { Component } from 'react'
import { connect } from "react-redux";
import Axios from "axios";
import "./style.css";
import { configuration } from "../appConfig";

export class PreDamageDentTable extends Component {
    state = {
        data: {},
        words: {},
        lang: "",
        allOtherPartImages : [
          "foggy_L",
          "meglena_D",
          "headlamp_L",
          "headlamp_D",
          "ventilationGrille",
          "emblem",
          "pvcLiningUnderVS_L",
          "pvcLiningUnderVS_D",
          "frontWiperLCover",
          "frontWiperDCover",
          "windscreen",
          "roofRail_L",
          "roofRail_D",
          "roofAntenna",
          "luggageCoverSpoiler",
          "luggageCoverGlass",
          "rearWiperCover",
          "interiorBrakeLight_L",
          "interiorBrakeLight_D",
          "fenderTurnSignal_L",
          "mirrorOutside_L",
          "turnSignalOnExteriorMirror_L",
          "doorHandle_EN",
          "doorTrimLower_EN",
          "slidingWindowTrim_EN",
          "topDoorSash_EN",
          "doorUpright_SL",
          "doorHandle_ZL",
          "doorTrimBelow_ZL",
          "slidingWindowSlat_ZL",
          "topDoorSash_ZL",
          "doorHinge_ZL",
          "zlDoorStile",
          "tankCover",
          "windowTriangle_ZL",
          "brakeLightExternal_L",
          "fenderTurnSignal_D",
          "mirrorOutside_D",
          "turnSignalOnOutsideMirror_D",
          "doorHandle_SD",
          "doorTrimLower_SD",
          "slidingWindowTrim_SD",
          "doorTrimAbove_SD",
          "doorStile_SD",
          "sdDoorHandle",
          "sdDoorTrimBelow",
          "slidingWindowMoulding_ZD",
          "upperDoorLeaf_ZD",
          "zdDoorUpStand",
          "zdDoorStile",
          "windowTriangle_ZD",
          "brakeLightExternal_D",
        ]
      };

      componentDidMount() {
        const partnerId = localStorage.getItem("partnerId");
        const vin = localStorage.getItem("selectedFile");
        Axios.get(
          `${configuration.getData}?vin=${vin}&partnerId=${partnerId}`
        ).then((r) => {
          if (r.data) {
            this.setState({ data: r.data });
          }
        });
        this.getLang();
      }
      getLang = () => {
        const base_url = window.location.origin;
        Axios.get(`${base_url}/lang.json`).then((res) => {
          this.setState({
            words: res.data,
            lang: localStorage.getItem("lang"),
          });
        });
      };
      static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.lang !== prevState.lang) {
          return { lang: nextProps.lang };
        } else return null;
      }
      lang = (word) => {
        const { lang, words } = this.state;
        return words[word] ? words[word][lang] : word;
      };


  render() {
    const { extraNewImages } = this.props;

    const filterArr = extraNewImages.filter((ele) => this.state.allOtherPartImages.includes(ele.part));
      // Sort the extraNewImages array based on orderno
      const sortedImages = filterArr && filterArr.length > 0  && filterArr.slice().sort((a, b) => {
        const orderA = this.state.allOtherPartImages.findIndex(item => item === a.part);
        const orderB = this.state.allOtherPartImages.findIndex(item => item === b.part);
        return orderA - orderB;
      });
      
    return (
        <div className="row p-0 text-muted hide-report">
        <div className="table-responsive">
          <table className="table table-bordered table-striped dent-table-2d text-center">
            <thead>
              <tr>
                <th>{this.lang("Sr. No")}</th>
                <th className='text-left'>{this.lang("Part")}</th>
              </tr>
            </thead>
            <tbody>
            {sortedImages && sortedImages.length > 0 &&
                sortedImages.map((r, i) => { 
                  let order = this.state.allOtherPartImages.findIndex(item => item === r.part);
                  let orderno = order + 1;
                  return (
                  <tr key={i}>
                    <td>{orderno}</td>
                    <td className='text-left'>{this.lang(r.part)}</td>
                  </tr>
                  )
                })
              }
            </tbody>
          </table>
        </div>
      </div>
    )
  }
}
const mapStateToProps = (props) => {
    return {
      lang: props.lang,
    };
  };
export default connect(mapStateToProps)(PreDamageDentTable)
